import React from 'react'
import { NavDropdown } from 'react-bootstrap'
import RwIconTextLink from '../../molecules/RwIconTextLink'
import RwIcon from '../../molecules/RwIcon'
import { useSiteContext } from '../../../context/site/SiteProvider'
import AccountDropdownItem from './AccountDropdownItem'
import { useUserContext } from '../../../context/user/UserProvider'

const AccountDropdownItems: React.FC = () => {
  const { appSettings } = useSiteContext()
  const { selectedAccountPage } = useUserContext()

  return (
    <>
      <AccountDropdownItem
        label="Orders"
        to="/account/orders"
        icon={<RwIcon icon="TruckIcon" />}
        selected={selectedAccountPage === 'Orders'}
      />

      <AccountDropdownItem
        label="Carts"
        to="/account/carts"
        icon={<RwIcon icon="CartIcon" />}
        selected={selectedAccountPage === 'Carts'}
      />

      <AccountDropdownItem
        label="Profile"
        to="/account/profile"
        icon={<RwIcon icon="AddressCardIcon" />}
        selected={selectedAccountPage === 'Profile'}
      />

      <AccountDropdownItem
        label="Password"
        to="/account/password"
        icon={<RwIcon icon="KeyIcon" />}
        selected={selectedAccountPage === 'Password'}
      />

      <AccountDropdownItem
        label="Preferences"
        to="/account/preferences"
        icon={<RwIcon icon="PreferencesIcon" />}
        selected={selectedAccountPage === 'Preferences'}
      />

      {appSettings?.is_checkout_disabled ? (
        <></>
      ) : (
        <AccountDropdownItem
          label="Documents"
          to="/account/documents"
          icon={<RwIcon icon="DocumentIcon" />}
          selected={selectedAccountPage === 'Documents'}
        />
      )}

      <AccountDropdownItem
        label="Downloads"
        to="/account/downloads"
        icon={<RwIcon icon="DocumentDownloadIcon" />}
        selected={selectedAccountPage === 'Downloads'}
      />
    </>
  )
}

export default AccountDropdownItems
